import { render } from "./SetLocationId.vue?vue&type=template&id=c0b7ac8e"
import script from "./SetLocationId.vue?vue&type=script&lang=js"
export * from "./SetLocationId.vue?vue&type=script&lang=js"
script.render = render

export default script